import {useMutation} from '@apollo/react-hooks';

import type {
    office365SetInitialSyncSettings as Office365SetInitialSyncSettingsMutation,
    office365SetInitialSyncSettingsVariables as Office365SetInitialSyncSettingsMutationVariables,
} from 'nutshell-graphql-types';

import OFFICE365_SET_INITIAL_SYNC_SETTINGS from '../mutations/office365-set-initial-sync-settings.graphql';

export function useOffice365SetInitialSyncSettings() {
    const [office365SetInitialSyncSettings, {loading, error}] = useMutation<
        Office365SetInitialSyncSettingsMutation,
        Office365SetInitialSyncSettingsMutationVariables
    >(OFFICE365_SET_INITIAL_SYNC_SETTINGS);

    return {
        office365SetInitialSyncSettings,
        isLoading: loading,
        error,
    };
}
